import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

let inputId = 0;

@Component({
    selector: 'ui-m020-c070-input-toggle',
    templateUrl: './m020-c070-input-toggle.component.html',
    styleUrl: './m020-c070-input-toggle.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ReactiveFormsModule],
})
export class M020C070InputToggleComponent {
    control = input.required<FormControl<boolean>>();
    label = input.required<string>();

    inputId = `form-input-toggle-${inputId++}`;
}
